import { useForm } from '@mantine/form'
import { notifications } from '@mantine/notifications'

import { useUpdateTagMutation } from '../api/tag.api'
import { type TagUpdateMutationData } from '../tag.types'

const useEditTag = () => {
  const [updateTagMutation, updateTagMutationStatus] = useUpdateTagMutation()

  const rowValuesForm = useForm<TagUpdateMutationData>({
    initialValues: { id: '' },
    mode: 'uncontrolled',
  })

  const handleUpdateTag = (onMutationSuccess: () => void) => {
    updateTagMutation({ data: rowValuesForm.getValues() })
      .unwrap()
      .then(() => onMutationSuccess())
      .catch((e) => {
        notifications.show({
          message: `update failed: ${e.data.message}`,
          color: 'red',
        })
      })
  }

  return {
    handleUpdateTag,
    updateTagMutationStatus: updateTagMutationStatus.status,
    rowValuesForm,
  }
}

export default useEditTag
